import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["innerHTML"]

import { IonIcon, IonSelect, IonSelectOption } from "@ionic/vue";
import { computed, ref, watch } from "vue";
import { Capacitor } from "@capacitor/core";

import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { INPUT_MODE, INPUT_TYPE, ION_SELECT_INTERFACE } from "@/types/enum/ionicEnum";
import { isApp } from "@/functions/enviroment";
import InputSimple from "@/components/input/InputSimple.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneDialCodeDropdown',
  props: {
    initCoutry: {},
    phone: {},
    colors: { default: 'coral-light-color' }
  },
  emits: ["update:phone", "valid"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const defaultCountry = { name: "Germany", iso2: "de", dialCode: "49", flag: "🇩🇪" }
const europeanCountries = [
    { name: "Albania", iso2: "al", dialCode: "355", flag: "🇦🇱" },
    { name: "Andorra", iso2: "ad", dialCode: "376", flag: "🇦🇩" },
    { name: "Austria", iso2: "at", dialCode: "43", flag: "🇦🇹" },
    { name: "Belgium", iso2: "be", dialCode: "32", flag: "🇧🇪" },
    { name: "Bosnia and Herzegovina", iso2: "ba", dialCode: "387", flag: "🇧🇦" },
    { name: "Bulgaria", iso2: "bg", dialCode: "359", flag: "🇧🇬" },
    { name: "Croatia", iso2: "hr", dialCode: "385", flag: "🇭🇷" },
    { name: "Cyprus", iso2: "cy", dialCode: "357", flag: "🇨🇾" },
    { name: "Czech Republic", iso2: "cz", dialCode: "420", flag: "🇨🇿" },
    { name: "Denmark", iso2: "dk", dialCode: "45", flag: "🇩🇰" },
    { name: "Estonia", iso2: "ee", dialCode: "372", flag: "🇪🇪" },
    { name: "Finland", iso2: "fi", dialCode: "358", flag: "🇫🇮" },
    { name: "France", iso2: "fr", dialCode: "33", flag: "🇫🇷" },
    { name: "Germany", iso2: "de", dialCode: "49", flag: "🇩🇪" },
    { name: "Greece", iso2: "gr", dialCode: "30", flag: "🇬🇷" },
    { name: "Hungary", iso2: "hu", dialCode: "36", flag: "🇭🇺" },
    { name: "Iceland", iso2: "is", dialCode: "354", flag: "🇮🇸" },
    { name: "Ireland", iso2: "ie", dialCode: "353", flag: "🇮🇪" },
    { name: "Italy", iso2: "it", dialCode: "39", flag: "🇮🇹" },
    { name: "Kosovo", iso2: "xk", dialCode: "383", flag: "🇽🇰" },
    { name: "Latvia", iso2: "lv", dialCode: "371", flag: "🇱🇻" },
    { name: "Liechtenstein", iso2: "li", dialCode: "423", flag: "🇱🇮" },
    { name: "Lithuania", iso2: "lt", dialCode: "370", flag: "🇱🇹" },
    { name: "Luxembourg", iso2: "lu", dialCode: "352", flag: "🇱🇺" },
    { name: "Malta", iso2: "mt", dialCode: "356", flag: "🇲🇹" },
    { name: "Moldova", iso2: "md", dialCode: "373", flag: "🇲🇩" },
    { name: "Monaco", iso2: "mc", dialCode: "377", flag: "🇲🇨" },
    { name: "Montenegro", iso2: "me", dialCode: "382", flag: "🇲🇪" },
    { name: "Netherlands", iso2: "nl", dialCode: "31", flag: "🇳🇱" },
    { name: "North Macedonia", iso2: "mk", dialCode: "389", flag: "🇲🇰" },
    { name: "Norway", iso2: "no", dialCode: "47", flag: "🇳🇴" },
    { name: "Poland", iso2: "pl", dialCode: "48", flag: "🇵🇱" },
    { name: "Portugal", iso2: "pt", dialCode: "351", flag: "🇵🇹" },
    { name: "Romania", iso2: "ro", dialCode: "40", flag: "🇷🇴" },
    { name: "San Marino", iso2: "sm", dialCode: "378", flag: "🇸🇲" },
    { name: "Serbia", iso2: "rs", dialCode: "381", flag: "🇷🇸" },
    { name: "Slovakia", iso2: "sk", dialCode: "421", flag: "🇸🇰" },
    { name: "Slovenia", iso2: "si", dialCode: "386", flag: "🇸🇮" },
    { name: "Spain", iso2: "es", dialCode: "34", flag: "🇪🇸" },
    { name: "Sweden", iso2: "se", dialCode: "46", flag: "🇸🇪" },
    { name: "Switzerland", iso2: "ch", dialCode: "41", flag: "🇨🇭" },
    { name: "Turkey", iso2: "tr", dialCode: "90", flag: "🇹🇷" },
    { name: "Ukraine", iso2: "ua", dialCode: "380", flag: "🇺🇦" },
    { name: "United Kingdom", iso2: "gb", dialCode: "44", flag: "🇬🇧" },
    { name: "Vatican City", iso2: "va", dialCode: "379", flag: "🇻🇦" }
];

const selectEl = ref()
const iconKey = ref(0)

function openSelect() {
    selectEl.value.$el.click()
}

const phoneInput = ref('')
const country = ref(defaultCountry);

const flagSrc = computed(() => country.value ? `assets/icon/flags/${country.value.iso2.toLowerCase()}.svg` : `assets/icon/globe.svg`)

function emitPhone() {
    const national = phoneInput.value.replace(/\s/g, "")
    const fullNumber = `+${country.value.dialCode}${national}`

    const parsed = parsePhoneNumberFromString(fullNumber)

    if (parsed?.isValid()) {
        emit("update:phone", parsed.format("E.164"))
        emit('valid', true) // valid
    } else {
        emit('valid', false) // invalid → empty string
    }
}

function sanitizePhone(value?: string | number): string {
    return String(value ?? '').replace(/[^0-9 ]/g, '') // remove everything except digits and spaces
}

function onPhoneInput(value?: string | number) {
    const sanitized = sanitizePhone(value)

    phoneInput.value = sanitized // update internal national number

    emitPhone() // combines with country and emits E.164
}

watch(phoneInput, emitPhone)
watch(country, emitPhone)

watch(() => props.phone, (val) => {
        if (!val) return

        const parsed = parsePhoneNumberFromString(val) || parsePhoneNumberFromString(`+${country.value.dialCode}${val}`)
        if (!parsed) return

        const found = europeanCountries.find(c => c.iso2.toUpperCase() === parsed.country)

        if (found) {
            country.value = found
        }

        iconKey.value++
        phoneInput.value = parsed.nationalNumber
    },
    { immediate: true }
)

watch(() => props.initCoutry, (iso) => {
        country.value = europeanCountries.find(c => c.iso2 === iso?.toLowerCase()) || defaultCountry
    },
    { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "country-container",
      onClick: openSelect
    }, [
      (!_unref(Capacitor).isNativePlatform())
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            src: flagSrc.value,
            class: _normalizeClass([__props.colors, "country-dropdown-icon"]),
            key: iconKey.value
          }, null, 8, ["src", "class"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(country.value.flag), 1)),
      _createVNode(_unref(IonSelect), {
        ref_key: "selectEl",
        ref: selectEl,
        "cancel-text": _ctx.$t('button.cancel'),
        interface: _unref(isApp)() ? _unref(ION_SELECT_INTERFACE).ALERT : _unref(ION_SELECT_INTERFACE).ACTION_SHEET,
        modelValue: country.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((country).value = $event)),
        onIonChange: () => {} /*selectChangeFunction*/,
        class: _normalizeClass(["country-dropdown", __props.colors]),
        "selected-text": `+${country.value.dialCode}`,
        mode: "ios",
        style: {"color":"black"}
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(europeanCountries, (country) => {
            return _createVNode(_unref(IonSelectOption), {
              key: country.iso2,
              value: country
            }, {
              default: _withCtx(() => [
                (_unref(Capacitor).isNativePlatform())
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: country.flag
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(country.name) + " (+" + _toDisplayString(country.dialCode) + ") ", 1)
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["cancel-text", "interface", "modelValue", "class", "selected-text"])
    ]),
    _createVNode(InputSimple, {
      modelValue: phoneInput.value,
      "onUpdate:modelValue": onPhoneInput,
      class: "grey4-grey4-background inherit-background purple-purple-color unset-max-width international",
      placeholder: _ctx.$t('placeholder.phone'),
      type: _unref(INPUT_TYPE).TEL,
      inputmode: _unref(INPUT_MODE).TEL,
      "input-class": "phone-input",
      "validate-option": { name: 'phone', label: _ctx.$t('label.phone') }
    }, null, 8, ["modelValue", "placeholder", "type", "inputmode", "validate-option"])
  ], 64))
}
}

})